module.exports = __webpack_public_path__ + "assets/img/ru-699f902d.png";